/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2019-09-24
 * @description Implementation of  companies and organizations inner page.
 * @filename invitation-lading.tsx
 */

import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import { ReadyState } from "../../../relay/ready-state";
import { RelayProps } from "../../../relay/relay-props";
import { Loader } from "../../page/loader";
import { Invitation } from "@radivision/graphql/lib/ts/graphql/invitation";
import { ActionModalProps, ActionModal } from "../../modals/action-modal";
import $ from "jquery";
import { RegistersForm } from "./registration-form";
import Review from "./profile-claim";
import { Router } from "../../../utilities/router";
import { SVG } from "../../../component-configuration/svgs";
import { Modal } from "../../modals/modal";
import { REACT_USER_CONTEXT } from "../../../contexts/react-user-context";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { getProfileInfo } from "../../../utilities/get-profile-info";
import { store } from "../../../redux";

const CONGRATS_GIF = require("../../../../static/congrats.jpg");
/**
 *
 */
const MODAL_ID = "2b58d598c083bce14b8c";

/**
 *
 *
 */
const LOGO = require("../../../../static/rv_logo_01.png");

/**
 *
 *
 */
const steps = ["Sign-up on Radivision", "Claim your profiles", "Ownership confirmation"];

/**
 *
 *
 * @export
 * @interface InvitationLandingPanelProps
 */
export interface InvitationLandingPanelProps extends RelayProps {
  /**
   *
   *
   * @type {string}
   * @memberof InvitationLandingPanelProps
   */
  string: string;

  /**
   *
   *
   * @type {string[]}
   * @memberof InvitationLandingPanelProps
   */
  errors?: string[];

  /**
   *
   *
   * @type {Invitation}
   * @memberof InvitationLandingPanelProps
   */
  invitation?: Invitation;

  /**
   *
   *
   * @type {Person}
   * @memberof InvitationLandingPanelProps
   */
  user?: Person;
}

export interface InvitationLandingPanelState {
  /**
   *
   *
   * @type {number}
   * @memberof InvitationLandingPanelState
   */
  activeSlide: number;

  /**
   *
   *
   * @type {boolean}
   * @memberof InvitationLandingPanelState
   */
  loading: boolean;

  /**
   *
   *
   * @type {ActionModalProps}
   * @memberof InvitationLandingPanelState
   */
  modalErrorProps?: ActionModalProps;
}

export class InvitationLandingPanel extends React.Component<InvitationLandingPanelProps, InvitationLandingPanelState> {
  constructor(props: InvitationLandingPanelProps) {
    super(props);
    let modalErrorProps: ActionModalProps;

    // ... bind needed function to class
    this.handleRegisterSuccess = this.handleRegisterSuccess.bind(this);
    this.handleClaimingSuccess = this.handleClaimingSuccess.bind(this);
    this.renderError = this.renderError.bind(this);
    this.triggerLoader = this.triggerLoader.bind(this);

    if (this.props.errors) {
      modalErrorProps = {
        buttonText: "ok",
        buttonAction: () => {
          window.location.assign("/");
        },
        modalMessageBody: this.props.errors[0],
        modalTitle: "Error",
      };
    }

    this.state = {
      modalErrorProps,
      activeSlide: 0,
      loading: false,
    };
  }

  /**
   *
   *
   * @memberof InvitationLandingPanel
   */
  handleRegisterSuccess(email: string, password: string) {
    this.setState({ loading: true });

    $(`#Invitation_Modal`).modal({
      keyboard: false,
      backdrop: "static",
      show: false,
    });

    return import("../../../authentication/cognito-client").then((module) => {
      return module.CognitoClient.loginWithEmailAndPassword(email, password)
        .then((res) => {
          this.setState({ activeSlide: 1, loading: false });
        })
        .catch((err) => {
          console.error(err);

          this.renderError(err.message);
        });
    });
  }

  componentDidUpdate() {
    if (this.props.user) {
      return import("../../../authentication/cognito-client").then((module) => {
        return module.CognitoClient.signOut(true).then(() => {
          location.reload();
        });
      });
    }
  }

  /**
   *
   *
   * @param {string} message
   * @memberof InvitationLandingPanel
   */
  renderError(message: string, buttonAction?: () => void) {
    const modalErrorProps: ActionModalProps = {
      buttonText: "ok",
      buttonAction: () => {
        $(`#${MODAL_ID}`).modal("hide");
        this.setState({ modalErrorProps: undefined });
      },
      modalMessageBody: message,
      modalTitle: "Error",
    };

    if (buttonAction) {
      modalErrorProps.buttonAction = buttonAction;
    }

    this.setState({ modalErrorProps, loading: false }, () => {
      $(`#${MODAL_ID}`).modal("show");
    });
  }
  /**
   *
   *
   * @memberof InvitationLandingPanel
   */
  handleClaimingSuccess(record: any) {
    this.setState({ loading: false });

    if (record === null || record === undefined) {
      this.renderError("Failed to claim profile, Please Contact Radivision technical support");
    } else {
      /// TODO CLAIM RESULTS AND NAVIGATE TO PROFILE
      this.setState({ activeSlide: 2 });
    }
  }
  /**
   *
   *
   * @param {number} slideId
   * @returns
   * @memberof InvitationLandingPanel
   */
  getSlideContent(slideId: number) {
    let NODE: React.ReactNode;

    switch (slideId) {
      case 0:
        NODE = (
          <RegistersForm
            {...{
              handleRegisterSuccess: this.handleRegisterSuccess,
              handleRegisterFailure: (message: string) => {
                console.error(message);
                this.renderError(message);
              },
              triggerLoader: this.triggerLoader,
            }}
          />
        );
        break;
      case 1:
        NODE =
          this.props.invitation && this.props.invitation.expiryDate ? (
            <Review
              {...{
                invitationId: this.props.string,
                expiryDate: this.props.invitation.expiryDate,
                actions: {
                  success: this.handleClaimingSuccess,
                  loading: () => {
                    this.setState({ loading: true });
                  },
                },
              }}
            />
          ) : null;
        break;
      //
      case 2:
        NODE = (
          <div className="container-fluid">
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={CONGRATS_GIF} alt="congratulations" className="logo d-inline-block" />
            </div>
            <button
              type="submit"
              className={"btn-root"}
              onClick={() => {
                try {
                  const state = store.getState();
                  const user = state.account.user;
                  const { profileUrl } = getProfileInfo(user);
                  Router.to(profileUrl);
                } catch (e) {
                  console.error("Error: Invitation Panel visit your profile", { e });
                }
              }}
            >
              Visit Your Profile
            </button>
          </div>
        );
        break;
      default:
        throw new Error("Unknown slide");
    }

    if (!NODE) {
      this.setState({
        modalErrorProps: {
          buttonText: "OK",
          modalTitle: "Error",
          modalMessageBody:
            "Invalid/expired invitation provided. please contact us at hello@radivision.com , and we will do so within ten (10) days of receiving your notice",
        },
      });
    }
    return NODE;
  }

  /**
   *
   *
   * @param {boolean} action
   * @memberof InvitationLandingPanel
   */
  triggerLoader(action: boolean): void {
    this.setState({ loading: action === undefined ? false : action });
  }
  /**
   *
   *
   * @returns {React.ReactNode}
   * @memberof InvitationLandingPane
   */
  render(): React.ReactNode {
    const activeSlide = this.state.activeSlide;
    return (
      <div className="container pb-1 pt-1 invitation-conatiner">
        <div className="makeStyles-paper-1">
          <div className="navbar-brand nav-logo">
            <img src={LOGO} alt="logo" className="logo d-inline-block" />
          </div>

          <ul className="stepper">
            {steps.map((label, index) => (
              <li key={index} className={`step${index <= activeSlide ? " active" : ""}`}>
                <span className="step">{index < activeSlide ? SVG.checkmark : index + 1}</span>
                <span className="step-label">{label}</span>
              </li>
            ))}
          </ul>

          {this.getSlideContent(activeSlide)}
        </div>

        {this.state.modalErrorProps ? (
          <Modal id={MODAL_ID} className="modal-dialog-centered modal-sm" title={this.state.modalErrorProps.modalTitle}>
            <ActionModal {...this.state.modalErrorProps} />
          </Modal>
        ) : null}

        <Loader isActive={this.state.loading} />
      </div>
    );
  }
}

/**
 * Company Details Container That Handle calls for company data.
 */
export class InvitationLandingPanelContainer extends React.Component<
  InvitationLandingPanelProps,
  InvitationLandingPanelState
> {
  /**
   *
   *
   * @returns
   * @memberof InvitationLandingPanelContainer
   */
  render(): React.ReactNode {
    const invitationId: string = this.props.string;
    let node: React.ReactNode;

    if (invitationId === undefined || invitationId === null) {
      const props: React.ComponentProps<any> = {
        ...this.props,
        id: null,
        errors: ["invalid invitation link"],
      };
      node = <InvitationLandingPanel {...props} />;
    } else {
      node = (
        <REACT_USER_CONTEXT.Consumer>
          {(value: { user: Person; updateUser: Function }) => (
            <QueryRenderer
              environment={this.props.relay.environment}
              query={graphql`
                query invitationPanelQuery($id: ID!) {
                  invitation(id: $id) {
                    hasErrors
                    errors {
                      id
                      location
                    }
                    invitation {
                      id
                      description
                      person
                      entity
                      expiryDate
                      created
                      __typename
                    }
                  }
                }
              `}
              variables={{ id: invitationId }}
              render={(
                readyState: ReadyState<{
                  invitation: any;
                }>,
              ): React.ReactElement<any> => {
                let internalNode: React.ReactElement<any>;
                const props: React.ComponentProps<any> = {
                  ...this.props,
                  id: null,
                  errors: [],
                  user: value.user,
                };

                if (readyState.error !== undefined && readyState.error !== null) {
                  props.errors = ["Unexpected error... Please contact Technical Radivision team"];
                  node = <InvitationLandingPanel {...props} />;
                } else if (readyState.props === undefined || readyState.props === null) {
                  internalNode = <div />;
                } else {
                  if (
                    readyState.props.invitation !== undefined &&
                    readyState.props.invitation !== null &&
                    readyState.props.invitation.invitation !== undefined &&
                    readyState.props.invitation.invitation !== null
                  ) {
                    const props: React.ComponentProps<any> = {
                      ...this.props,
                      id: readyState.props.invitation.invitation.id,
                      invitation: readyState.props.invitation.invitation,
                      user: value.user,
                    };

                    internalNode = <InvitationLandingPanel {...props} />;
                  } else {
                    props.errors = ["Unexpected error... Please contact Technical Radivision team"];
                    internalNode = <InvitationLandingPanel {...props} />;
                  }
                }
                return internalNode;
              }}
            />
          )}
        </REACT_USER_CONTEXT.Consumer>
      );
    }
    return node;
  }
}
